<template style="height: 100%;">
  <div class="File_individual">
          <ul class="Personal_file_right">
          <li id="General">
            <div class="Personal_file_title">
              <h2>1、个人信息 <span style="color: red;font-size: 14px;font-weight: 000;margin-left: 10px;">* 为必填项</span></h2>
            </div>

            <el-descriptions class="margin-top" :span="4" :column="2" :size="size" border style="margin-top: 20px;width: 98%;margin-left: 1%;">
          
              <el-descriptions-item>
                <template slot="label">
                  <i style="color: red;">*</i> 姓名
                </template>
                <el-input v-model="form.Realname"></el-input>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i style="color: red;">*</i> 性别
                </template>

                <el-radio-group v-model="form.Sex">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="0">女</el-radio>
                </el-radio-group>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i style="color: red;">*</i> 年龄
                </template>
                <el-date-picker v-model="form.Age" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                 <i style="color: red;">*</i> 军人证件号
                </template>
                <el-input v-model="form.UserID"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                <i style="color: red;">*</i> 联系方式
                </template>
                <el-input v-model="form.Phone"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                <i style="color: red;">*</i> 安全邮箱
                </template>
                <el-input v-model="form.Email"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  户籍类型
                </template>
                <el-radio-group v-model="form.AccountType">
                  <el-radio label="0">城市</el-radio>
                  <el-radio label="1">农村</el-radio>
                </el-radio-group>

              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  婚姻状态
                </template>

                <el-select v-model="form.MarriageState" placeholder="请选择">
                  <el-option label="已婚" value="1"></el-option>
                  <el-option label="未婚" value="2"></el-option>
                  <el-option label="离异" value="3"></el-option>
                  <el-option label="丧偶" value="4"></el-option>
                  <el-option label="再婚" value="5"></el-option>
                  <el-option label="其他" value="6"></el-option>
                </el-select>

              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  兵种
                </template>
                <el-select v-model="form.ArmyType" placeholder="请选择">
                  <el-option label="海军" value="2"></el-option>
                  <el-option label="空军" value="3"></el-option>
                  <el-option label="陆军" value="1"></el-option>
                  <el-option label="火箭军" value="4"></el-option>
                  <el-option label="战略支援部队" value="6"></el-option>
                  <el-option label="联勤保障部队" value="5"></el-option>
                  <el-option label="其他" value="7"></el-option>
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  军衔
                </template>
                <el-select v-model="form.Cliniclype" placeholder="请选择">
                  <el-option label="上将" value="1"></el-option>
                  <el-option label="中将" value="2"></el-option>
                  <el-option label="少将" value="3"></el-option>
                  <el-option label="大校" value="4"></el-option>
                  <el-option label="上校 " value="5"></el-option>
                  <el-option label="中校" value="6"></el-option>
                  <el-option label="少校" value="7"></el-option>
                  <el-option label="大尉" value="8"></el-option>
                  <el-option label="上尉" value="9"></el-option>
                  <el-option label="中尉" value="10"></el-option>
                  <el-option label="少尉" value="11"></el-option>
                  <el-option label="上士" value="12"></el-option>
                  <el-option label="中士" value="13"></el-option>
                  <el-option label="下士" value="14"></el-option>
                  <el-option label="上等兵" value="15"></el-option>
                  <el-option label="列兵" value="16"></el-option>
                  <el-option label="四级军士长" value="17"></el-option>
                  <el-option label="三级军士长" value="18"></el-option>
                  <el-option label="二级军士长" value="19"></el-option>
                  <el-option label="一级军士长" value="20"></el-option>
    
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  文化程度
                </template>
                <el-select v-model="form.Degree" placeholder="请选择">
                  <el-option label="博士生" value="1"></el-option>
                  <el-option label="硕士" value="2"></el-option>
                  <el-option label="本科" value="3"></el-option>
                  <el-option label="大专" value="4"></el-option>
                  <el-option label="中专" value="5"></el-option>
                  <el-option label="高中" value="6"></el-option>
                  <el-option label="初中" value="7"></el-option>
                  <el-option label="小学" value="8"></el-option>
                  <el-option label="文盲" value="9"></el-option>
                  <el-option label="其他" value="10"></el-option>
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  职级
                </template>
                <el-select v-model="form.Positionlevel" placeholder="请选择">
                  <el-option label="现役军官" value="1"></el-option>
                  <el-option label="文职干部" value="2"></el-option>
                  <el-option label="士兵" value="3"></el-option>
                  <el-option label="文职人员" value="4"></el-option>
                  <el-option label="职工" value="5"></el-option>
                  <el-option label="招聘人员" value="6"></el-option>
                  <el-option label="离退休人员" value="7"></el-option>
                  <el-option label="其他" value="8"></el-option>
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  部队名称
                </template>
                <el-input v-model="form.DeptID"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  技术职别
                </template>
                <el-select v-model="form.Skil1Level" placeholder="请选择">
                  <el-option label="技术职别1" value="1"></el-option>
                  <el-option label="技术职别2" value="2"></el-option>
                  <el-option label="技术职别3" value="3"></el-option>
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  文职级别
                </template>
                <el-select v-model="form.Bak2" placeholder="请选择">
                  <el-option label="文职级别1" value="1"></el-option>
                  <el-option label="文职级别2" value="2"></el-option>
                  <el-option label="文职级别3" value="3"></el-option>
                </el-select>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  是否退役
                </template>
                <el-select v-model="form.State" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  入伍时间
                </template>
          
                <el-date-picker v-model="form.EntryDate" type="date" placeholder="选择日期"></el-date-picker>
          
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  紧急联系人
                </template>
                <el-input v-model="form.TheGuardian"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  紧急联系电话
                </template>
                <el-input v-model="form.TheGuardianPhone"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  出生地
                </template>
                <el-input v-model="form.Bak3"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  生长地
                </template>
                <el-input v-model="form.Bak4"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  心理状况
                </template>
                <el-radio-group v-model="form.Bak5">
                  <el-radio label="健康"  value="1"   ></el-radio>
                  <el-radio label="比较健康" value="2"></el-radio>
                  <el-radio label="一般" value="3"></el-radio>
                  <el-radio label="不健康" value="4"></el-radio>
                  <el-radio label="疾病状态" value="5"></el-radio>
                </el-radio-group>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">身体状况</template>
                <el-radio-group v-model="form.Bak6">
                  <el-radio label="健康" value="1"></el-radio>
                  <el-radio label="比较健康" value="2"></el-radio>
                  <el-radio label="一般" value="3"></el-radio>
                  <el-radio label="不健康" value="4"></el-radio>
                  <el-radio label="疾病状态" value="5"></el-radio>
                </el-radio-group>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  夫妻情感
                </template>
                <el-input type="textarea" v-model="form.Bak7"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  夫/妻病史
                </template>
                <el-input type="textarea" v-model="form.Bak8"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  个人爱好
                </template>
                <el-input type="textarea" v-model="form.Bak9"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  个人病史
                </template>
                <el-input type="textarea" v-model="form.Bak10"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  自我评价
                </template>
                <el-input type="textarea" v-model="form.ZSelfIntroduction"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  家庭经济情况
                </template>
                <el-input type="textarea" v-model="form.Bakl1"></el-input>
              </el-descriptions-item>
              <!-- 家庭经济情况 还是 家庭婚姻状说 -->

        
            </el-descriptions>

            <div class="Personal_file_title">
              <h2>2、父亲信息</h2>
            </div>
            <el-descriptions class="margin-top" :column="2" :size="size" border
              style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item>
                <template slot="label">
                  年纪
                </template>
                <el-input v-model="form.FatherAge"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  职业
                </template>
                <el-input v-model="form.FatherDuty"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  身体情况
                </template>

                <el-radio-group v-model="form.FatherState">
                  <el-radio label="1">健康</el-radio>
                  <el-radio label="2">疾病</el-radio>
                  <el-radio label="3">离世</el-radio>
                </el-radio-group>


              </el-descriptions-item>
            </el-descriptions>

            <div class="Personal_file_title">
              <h2>3、母亲信息</h2>
            </div>
            <el-descriptions class="margin-top" :column="2" :size="size" border
              style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item>
                <template slot="label">
                  年纪
                </template>
                <el-input v-model="form.MotherAge"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  职业
                </template>
                <el-input v-model="form.MotherDuty"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  身体情况
                </template>
                <el-radio-group v-model="form.MotherState">
                  <el-radio label="1">健康</el-radio>
                  <el-radio label="2">疾病</el-radio>
                  <el-radio label="3">离世</el-radio>
                </el-radio-group>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  父母婚姻状态
                </template>

                <el-select v-model="form.ParentMerryState">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="离异" value="2"></el-option>
                  <el-option label="父再婚" value="3"></el-option>
                  <el-option label="母再婚" value="4"></el-option>
                  <el-option label="父母都再婚" value="5"></el-option>
                </el-select>

              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  父母病史
                </template>
                <el-input type="textarea" v-model="form.MedicalHistory"></el-input>
              </el-descriptions-item>

            </el-descriptions>

            <div class="Personal_file_title">
              <h2>4、姊妹信息</h2>
            </div>

            <el-descriptions class="margin-top" :column="2" :size="size" border
              style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item>
                <template slot="label">
                  姊妹信息
                </template>

                <el-radio-group v-model="form.HasSister">
                  <el-radio label="0">无</el-radio>
                  <el-radio label="1">有</el-radio>
                </el-radio-group>

              </el-descriptions-item>
            </el-descriptions>

            <div class="Personal_file_title">
              <h2>4、子女</h2>
            </div>
        
            <el-descriptions class="margin-top" :column="2" :size="size" border
              style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item>
                <template slot="label">
                  子女信息
                </template>

                <el-radio-group v-model="form.HasChildren">
                  <el-radio v-model="form.radio" label="0">无</el-radio>
                  <el-radio v-model="form.radio" label="1">有</el-radio>
                </el-radio-group>
              </el-descriptions-item>
            </el-descriptions>

          </li>
          <li id="Grow">
            <div class="Personal_file_title">
              <h2>5、抚养史</h2>
            </div>
            <el-descriptions class="margin-top" :column="2" :size="size" border style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item v-for="( item, i) in form.Bring" :key="i"  :span="2">

                <template slot="label">
                  抚养史
                </template>
            
                <el-input-number style="margin-right: 10px;" v-model="form.Bring[i].StartAge" :min="1" :max="100" label="描述文字"></el-input-number>
                至
                <el-input-number v-model="form.Bring[i].EndAge" :min="1" :max="100" label="描述文字" style="margin-left: 10px;margin-right: 10px;"></el-input-number>
                由
                <el-input style="display: inline-block;width: 180px;margin-right: 20px;margin-left: 10px;margin-right: 10px;" v-model="form.Bring[i].Supporter" ></el-input>抚养
                <el-button type="primary" @click="Add_Dependant" style="margin-left: 20px;">添加</el-button>
              </el-descriptions-item>
            </el-descriptions>

            <div class="Personal_file_title">
              <h2>6、成长史</h2>
            </div>

            <el-descriptions class="margin-top" :column="2" :size="size" border style="margin-top: 20px;width: 98%;margin-left: 1%;">
              <el-descriptions-item>
                <template slot="label">
                  父亲性格
                </template>
                <el-input type="textarea" v-model="form.GrowFatherNature"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  父亲教育方式
                </template>
                <el-input type="textarea" v-model="form.GrowFatherTrainWay"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  母亲性格
                </template>
                <el-input type="textarea" v-model="form.GrowMotherNature"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  母亲教育方式
                </template>
                <el-input type="textarea" v-model="form.GrowMotherTrainWay"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  父母关系
                </template>
                <el-input type="textarea" v-model="form.GrowParentRelationship"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  家庭气氛
                </template>
                <el-input type="textarea" v-model="form.GrowFamilyMood"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  抚养人性格（非父母抚养）
                </template>
                <el-input type="textarea" v-model="form.GrowSupporterNature"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  抚养人教育方式（非父母抚养）
                </template>
                <el-input type="textarea" v-model="form.GrowSupporterTrainWay"></el-input>
              </el-descriptions-item>
            </el-descriptions>

          </li>
          <li id="Army">
            <div class="Personal_file_title">
              <h2>7、军旅史</h2>
            </div>
            <el-descriptions class="margin-top" :column="2" :size="size" border style="margin-top: 20px;width: 98%;margin-left: 1%;">
        
              <el-descriptions-item>
                <template slot="label">
                  入伍前工作
                </template>
                <el-input type="textarea" v-model="form.ExperienceBeforeAmry"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  入伍动机
                </template>
                <el-input type="textarea" v-model="form.ArmyCause"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  个人特征
                </template>
                <el-input type="textarea" v-model="form.IndividualTraits"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  入伍后适应情况及时间
                </template>
                <el-input type="textarea" v-model="form.AdaptStateTime"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  专业技能特长
                </template>
                <el-input type="textarea" v-model="form.skill"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  任职经历及心理变化情况
                </template>
                <el-input type="textarea" v-model="form.ExperiencePsychology"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  参军后自豪的事情（列举1-3项）
                </template>

                <el-input type="textarea" v-model="form.ProudEventAfterArmy"></el-input>
              </el-descriptions-item>
        
              <el-descriptions-item>
                <template slot="label">
                  参军后受挫的事情（列举1-3项）
                </template>
                <el-input type="textarea" v-model="form.BadlEventAfterArmy"></el-input>
              </el-descriptions-item>

            </el-descriptions>
        
            <el-button @click="submit()" type="primary" style="margin-top: 10px;margin-bottom: 10px;position: fixed;bottom: 60px;left: 48%;">提 交</el-button>
          </li>
        </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      size: '',
      form: {
        Bring: [{
          StartAge: '',//开始年龄
          EndAge: '', //结束年龄
          Supporter: '', //扶养人
        }],
        ExperienceBeforeAmry: '',//入伍前工作经历
        ArmyCause: '',//入伍动机
        IndividualTraits: '',//个性特征
        AdaptStateTime: '',//入伍后适应情况及时间
        skill: '',//专业技能特长
        ExperiencePsychology: '',//任职经历及心理变化情况
        ProudEventAfterArmy: '',//参军后自豪的事情
        BadlEventAfterArmy: '',//参军后受挫的事情
        FatherDuty: '',//父亲职业
        FatherAge: '',//父亲年龄
        FatherState: '',//父亲身体状况: 健康、疾病、离世
        MotherDuty: '',//母亲职业
        MotherAge: '',//母亲年龄
        MotherState: '1',//母亲身体状况: 健康、疾病、离世
        ParentMerryState: '',//父母婚姻状态
        MedicalHistory: '',//父母病史
        HasSister: '',//姐妹: 有、无
        HasChildren: '',//子女: 有、无
        GrowFatherNature: '',//父亲性格 
        GrowFatherTrainWay: '',//父亲教养方式
        GrowMotherNature: '',//母亲性格
        GrowMotherTrainWay: '',//母亲教养方式
        GrowParentRelationship: '',//父母关系
        GrowFamilyMood: '',//家庭氛围
        GrowSupporterNature: '',//扶养人性格(非父母抚养)
        GrowSupporterTrainWay: '',//扶养人教养方式(非父母抚养)
        AccountType: '',//户口类型 0-农村 1-城市
        MarriageState: '',//婚姻状态
        ArmyType: '',//兵种
        Cliniclype: '',//军街
        Degree: '',// 文化程度
        Positionlevel: '',//职级
        DeptID: '',//部队名称
        EntryDate: '',//入伍时间
        Skil1Level: '',//技术职别
        Bak2: '',//文职级别
        State: '',//是否退役
        Bak3: '',//出生地
        Bak4: '',//生长地
        Bak5: '',//心理状况
        Bak6: '',//身体状况
        Bak7: '',//夫妻感情
        Bak8: '',//夫/妻病史
        Bak9: '',//个人爱好
        Bak10: '',//个人病史
        ZSelfIntroduction: '',//自我评价
        Bakl1: '',//家庭婚姻状说
        UserID: '',//军认证件号 
        Realname: '',//姓名
        Sex: '1',//性别
        Age: '',//年龄
        Phone: '',//联系方式
        Email: '',//电子邮件
        TheGuardian: '',//紧急联系人
        TheGuardianPhone: ''//紧急联系人电话
      },

    }
  },
  components: {

  },
  methods: {
    submit() {

      if (!this.form.Realname) {
        document.getElementById("General").scrollIntoView();
        this.Global.request_failure('请输入姓名！');
        return false
      }

      if (!this.form.UserID) {
        document.getElementById("General").scrollIntoView();
        this.Global.request_failure('请输入军认证件号！');
        return false
      }

      if (!this.form.Age) {
        document.getElementById("General").scrollIntoView();
        this.Global.request_failure('请输入年龄！');
        return false
      }

      if (!this.form.Phone) {
        document.getElementById("General").scrollIntoView();
        this.Global.request_failure('请输入联系方式！');
        return false
      } else if (this.Global.regMobile.test(this.form.Phone)) { } else {
        this.Global.request_failure('请输入正确手机格式！');
        return false
      }

      if (!this.form.Email) {
        document.getElementById("General").scrollIntoView();
        this.Global.request_failure('请输入电子邮件！');
        return false
      } else {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(this.form.Email)) {
          this.Global.request_failure('请输入正确电子邮件！');
          return false
        }
      }

      this.$Http_Post('SoldierFile/AddSoldierFile', { 'from': this.form }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {

        } else {

        }
      })
    },
    Add_Dependant() {
      this.form.Bring.push({ StartAge: '', EndAge: '', Supporter: '' })
    },
  },
  watch: {

  },
  mounted() {


  }
}
</script>

<style>

</style>
